import axios from 'axios'

/**
 * 取得 feeds 資訊
 * @param {Object} params - api 參數
 * @param {Array}  params.feedable_types - 欲取得的 feedable_type 類型 (refer: modules/feeds/constants/feedable_types)
 * @param {String} params.stock_id - (optional) stock id
 * @param {Array}  params.tag_ids - (optional) 概念股 id
 * @param {Number} params.per_page - (optional) 欲取得的分頁資料數量
 * @param {String} params.min_time - (optional) date range start time
 * @param {String} params.max_time - (optional) date range end time
 * @return {Promise} axios promise
 */
export function requestFeeds({ params }) {
  return axios.get('/api/v2/feeds', { params })
}

/**
 * 建立 Tweet
 * @param {String} content - Tweet 內容
 * @param {String} stockId - 欲建立在哪支股票下的 stock id
 * @return {Promise} axios promise
 */
export function requestCreateTweet({ content, stockId }) {
  return axios.post('/api/v2/feeds/tweets', {
    content,
    stock_id: stockId,
  }, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  })
}

/**
 * 刪除 tweet
 * @param {Number} id - 欲刪除的 tweet id
 * @return {Promise} axios promise
 */
export function requestDeleteTweet({ id }) {
  return axios.delete(`/api/v2/feeds/tweets/${id}`, {
    responseType: 'json',
  })
}

/**
 * 在 feed 下建立 comment
 * @param {Number} feedId - feed id
 * @param {String} content - comment 內容
 * @return {Promise} axios promise
 */
export function requestCreateComment({ feedId, content }) {
  return axios.post(`/api/v2/feeds/${feedId}/comments`, {
    content,
  })
}

/**
 * 刪除 comment
 * @param {Number} commentId - comment id
 * @return {Promise} axios promise
 */
export function requestDeleteComment({ feedId, commentId }) {
  return axios.delete(`/api/v2/feeds/${feedId}/comments/${commentId}`)
}

/**
 * 推薦單一 feed
 * @param {Number} feedId - feed id
 * @return {Promise} axios promise
 */
export function requestCreateLikeFeed({ feedId }) {
  return axios.post(`/api/v2/feeds/${feedId}/liking`, null, {
    responseType: 'json',
  })
}
/**
 * 取消推薦單一 feed
 * @param {Number} feedId - feed id
 * @return {Promise} axios promise
 */
export function requestDeleteLikeFeed({ feedId }) {
  return axios.delete(`/api/v2/feeds/${feedId}/liking`, {
    responseType: 'json',
  })
}

/**
 * 推薦 comment
 * @param {Number} feedId - feed id
 * @param {Number} commentId - comment id
 * @return {Promise} axios promise
 */
export function requestCreateLikeComment({ feedId, commentId }) {
  return axios.post(`/api/v2/feeds/${feedId}/comments/${commentId}/like`, null, {
    responseType: 'json',
  })
}

/**
 * 取消推薦 comment
 * @param {Number} feedId - feed id
 * @param {Number} commentId - comment id
 * @return {Promise} axios promise
 */
export function requestDeleteLikeComment({ feedId, commentId }) {
  return axios.delete(`/api/v2/feeds/${feedId}/comments/${commentId}/like`, {
    responseType: 'json',
  })
}
